export default __webpack_public_path__ + "static/media/pmsbottom.51bf8735.svg";